const SoftwareCompanyHowItWork = () => {
  return (
    <>
      <section className="sc-htw-section bg-light-subtle position-relative z-1 overflow-hidden ptb-120 border-line-bg">
        <div className="container">
          <div className="row justify-content-center justify-content-xxl-start">
            <div className="col-xxl-6 col-lg-7">
              <div className="section-title text-center text-xxl-start">
                <h2 className="mb-0 clr-text">
                  Our smart working process to goal with business
                </h2>
              </div>
            </div>
          </div>
          <img
            src="assets/img/software-company/line-doted.png"
            alt="not found"
            className="img-fluid mt-40 mb-4 line-doted"
          />
          <div className="row g-4 justify-content-center">
            <div className="col-xxl-3 col-xl-4 col-md-6">
              <div className="htw-single-item bg-white rounded">
                <div className="d-flex align-items-center">
                  <span className="icon-wrapper position-relative">
                    <h4 className="mb-0 text-white position-absolute start-50 top-50 translate-middle">
                      01
                    </h4>
                    <img
                      src="assets/img/software-company/icon-shape-1.png"
                      alt="icon"
                    />
                  </span>
                  <h5 className="mb-0 ms-3">Set project business goals</h5>
                </div>
                <p className="mb-0 mt-3">
                  We provide best IT solutions for any type of business.
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-md-6">
              <div className="htw-single-item bg-white rounded">
                <div className="d-flex align-items-center">
                  <span className="icon-wrapper position-relative">
                    <h4 className="mb-0 text-white position-absolute start-50 top-50 translate-middle">
                      02
                    </h4>
                    <img
                      src="assets/img/software-company/icon-shape-2.png"
                      alt="icon"
                    />
                  </span>
                  <h5 className="mb-0 ms-3">Research the Market</h5>
                </div>
                <p className="mb-0 mt-3">
                  We provide best IT solutions for any type of business.
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-md-6">
              <div className="htw-single-item bg-white rounded">
                <div className="d-flex align-items-center">
                  <span className="icon-wrapper position-relative">
                    <h4 className="mb-0 text-white position-absolute start-50 top-50 translate-middle">
                      03
                    </h4>
                    <img
                      src="assets/img/software-company/icon-shape-3.png"
                      alt="icon"
                    />
                  </span>
                  <h5 className="mb-0 ms-3">Understand your brand identity</h5>
                </div>
                <p className="mb-0 mt-3">
                  We provide best IT solutions for any type of business.
                </p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-md-6">
              <div className="htw-single-item bg-white rounded">
                <div className="d-flex align-items-center">
                  <span className="icon-wrapper position-relative">
                    <h4 className="mb-0 text-white position-absolute start-50 top-50 translate-middle">
                      04
                    </h4>
                    <img
                      src="assets/img/software-company/icon-shape-4.png"
                      alt="icon"
                    />
                  </span>
                  <h5 className="mb-0 ms-3">Design and test final output</h5>
                </div>
                <p className="mb-0 mt-3">
                  We provide best IT solutions for any type of business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SoftwareCompanyHowItWork;
